export enum HttpStatus {
  Ok = 200,
  Created = 201,
  NoContent = 202,
  BadRequest = 400,
  NotFound = 404,
  InternalServerError = 500,
}

export interface API_Response<T> {
  data: T;
  message: string;
  statusCode: HttpStatus;
}
